import React,{useState,useEffect} from "react";
import {
    Badge,
    Card,
    CardBody,
    Col,
    Container,
    Row, Table
} from "reactstrap";
import API from "../../utils/API";
import Loader from "../../components/Loader";
import DateRange from "../../components/formfields/DateRange";
import dateFormat from "dateformat";
import Pagination from "../../components/Pagination";
import ListStat from "../../components/ListStat";

const PaymentsDetails = () => {
    const defaultDate = dateFormat((new Date()).setDate((new Date()).getDate() - 30),"mmm d, yyyy")+" to "+dateFormat(new Date(),"mmm d, yyyy")

    const [filtration,setFiltration] = useState({page:1,perPage:100,date:defaultDate})
    const [payments, setPayments] = useState(null)
    const [loading, setLoading] = useState(true)
    const [data,setData] = useState(null)

    const changeData = (name,value) => {
        setFiltration({ ...filtration, [name]: value })
    }

    useEffect(() => {
        setLoading(true)
        API.post('/admin/billing/paymentsdetails',filtration).then((response) => {
            setPayments(response?.data?.data?.data)
            setData(response.data.data)
            setLoading(false)
        });
    }, [filtration])

    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-3">Transactions</h1>
            <div className="row mt-1 mb-2">
                <div className="col-3">
                    <label>Transaction date</label>
                    <DateRange
                        onChange={changeData}
                        name={'date'}
                        value={defaultDate}
                    />
                </div>
            </div>
            <Row>
                <Col>
                    <Card>
                        {loading &&
                            <CardBody><Loader/></CardBody>
                        }
                        {(!loading && payments && payments.length > 0) ?
                            <div className="table-responsive">
                                <ListStat data={data}/>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>User</th>
                                        <th>Product</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        payments.map((payment, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{payment.billingpayments.dateadd}</td>
                                                    <td>${Math.round(payment.billingpayments.amount/100)}</td>
                                                    <td><Badge color="success" className="mr-1 mb-1">
                                                        Success
                                                    </Badge></td>
                                                    <td>{payment.user.name}<br/><small>{payment.user.email}</small></td>
                                                    <td>{payment.product.title}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            :
                            !loading &&
                            <CardBody className="text-center"><h5>Data not found</h5></CardBody>
                        }
                    </Card>
                    {(data?.page > 0 && data?.pages > 0) &&
                        <Pagination
                            onChange={changeData}
                            name={"page"}
                            page={data.page}
                            totalPages={data.pages}
                            loading={loading}/>
                    }
                </Col>
            </Row>
        </Container>
    )
}

export default PaymentsDetails;
